import { render, staticRenderFns } from "./linkbutton.vue?vue&type=template&id=3e634fd2&"
import script from "./linkbutton.vue?vue&type=script&lang=js&"
export * from "./linkbutton.vue?vue&type=script&lang=js&"
import style0 from "./linkbutton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports